var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,64C14.4,64,0,49.6,0,32S14.4,0,32,0s32,14.4,32,32S49.6,64,32,64z M32,4.9C17,4.9,4.9,17,4.9,32 S17,59.1,32,59.1S59.1,47,59.1,32S47,4.9,32,4.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9,19.1c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6s-3.6,1.6-3.6,3.6S25.9,19.1,27.9,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9,19.4c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9c2.1,0,3.8,1.7,3.8,3.9S30.1,19.4,27.9,19.4z M27.9,12.1 c-1.8,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4s3.3-1.5,3.3-3.4S29.8,12.1,27.9,12.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,44.4c-0.7-1-1.9-1.2-3-0.7L45,44.9l-6.4-8.5c-0.4-0.6-1.2-0.9-1.8-0.9h-6.5v-3.8h7.5 c1.3,0,2.2-0.9,2.2-2.1c0-1.3-1-2.2-2.2-2.2h-7.5v-4.1c0-1.3-0.9-2.1-2.2-2.1c-1.3-0.1-2.3,0.8-2.3,2v14.7c0,1.2,0.9,2.1,2.2,2.1 h7.5l7,9.3c0.4,0.5,1,0.8,1.8,0.8c0.4,0,0.8-0.1,1.1-0.3l3.6-2.3c0.6-0.3,1-0.8,1.1-1.5C50.5,45.4,50.4,44.8,50,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.9,43.9L35.9,43.9c-0.4-0.2-0.9-0.4-1.4-0.1c-0.4,0.1-0.7,0.5-0.8,0.8c-1.1,2-3,3.5-5.4,4.2 c-2.3,0.7-4.6,0.4-6.8-0.8c-4.3-2.4-5.8-7.9-3.4-12.3c1.2-2,3-3.4,5.1-4.1c0.9-0.4,1.3-1.2,0.9-2c-0.2-0.5-0.6-0.8-1-1 c-0.3-0.1-0.7-0.1-0.9,0c-6.3,2-9.9,8.9-7.9,15.4c1.6,5,6.2,8.4,11.7,8.4c0.1,0,0.2,0,0.2,0c1.2,0,2.4-0.2,3.5-0.6 c2.8-0.9,5.2-2.9,6.8-5.6l0.1-0.3v-0.2C36.7,45.3,36.6,44.4,35.9,43.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType21);
export default __webpack_public_path__ + "static/media/aioa-icon-type-21.2e2c16f363e82d25c7627e02107d80cb.svg";
export { ForwardRef as ReactComponent };